<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs :crm_id="this.$route.params.crmid"/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>项目列表</span>
          </div>
          <div class="searchList">
            <!-- <div class="box-content">
                <label class="form-tit">院校名称</label>
                <el-input
                  v-model="searchData.sh_name"
                  class="jm-input280"/>
              </div>
              <div class="box-content">
                <label class="form-tit">研究科</label>
                <el-input
                  v-model="searchData.gs_name"
                  class="jm-input280"/>
              </div>
              <div class="box-content">
                <label class="form-tit">教授名称</label>
                <el-input
                  v-model="searchData.prof_name"
                  class="jm-input280"/>
              </div>
              <div class="box-content">
                <label class="form-tit">邮箱</label>
                <el-input
                  v-model="searchData.prof_email"
                  class="jm-input280"/>
              </div>
              <div class="box-content">
                <label class="form-tit">教授标签</label>
                <el-input
                  v-model="searchData.prof_tags"
                  class="jm-input280"/>
              </div>
              <div class="box-content">
                <label class="form-tit">研究方向</label>
                <el-input
                  v-model="searchData.prof_major"
                  class="jm-input280"/>
              </div>
              <div class="box-content">
                <label class="form-tit">备注</label>
                <el-input
                  v-model="searchData.prof_remark"
                  class="jm-input280"/>
              </div> -->
            <!-- <div class="box-content">
                <label class="form-tit">关键字</label>
                <el-input
                  v-model="searchData.keyword"
                  class="jm-input280"/>
              </div> -->
          </div>
          <!-- <div class="searchBottom">
              <el-button
                class="jm-input-common3"
                type="primary"
                @click="() => this.$store.commit('updateRefresh', true)">搜索</el-button>
              <el-button
                class="jm-input-common3"
                type="default"
                @click="resetFields">重置</el-button>
            </div> -->
          <!--列表部分 start -->
          <jm-tableList
            url="/index/offer/project"
            :search-data="searchData"
          >
            <el-table-column
              slot="lastColumn"
              label="操作"
              width="150">
              <template slot-scope="scope">
                <router-link :to="{ name: 'offerProjectDetail', params: { id: scope.row.id } }">
                  <el-button type="primary" size="mini" icon="el-icon-document">查看</el-button>
                </router-link>
              </template>
            </el-table-column>
          </jm-tableList>
          <!--列表部分 end-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList';

export default {
  data() {
    return {
      searchData: {},
      btnLoading: false,
    };
  },
  computed: {
  },
  methods: {
    // 重置搜索
    resetFields() {
      this.searchData = {};
      this.$store.commit('updateRefresh', true);
    },
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList,
  }
};
</script>
<style scoped>
</style>
